<!--产融专户开户申请-->
<template>
  <div v-loading="loading" class="form-container">
    <div class="repayment-apply-title">产融还款专户申请开通</div>
    <account-opening
      :page-from="$route.query.pageFrom"
      :re-submit-btn="$route.query.reSubmitBtn"
      :apply-id="$route.query.applyId"
      @closePage="closeAccountOpening"
    ></account-opening>
  </div>
</template>

<script>
// import Api from '@/modules/projectA/api/paymentAccount/index';
import AccountOpening from '@/modules/projectA/pages/repaymentAccountMgt/common/stepOne';
import bus from '@/components/common/bus';

export default {
  name: 'FinancialAccountOpening',
  components: { AccountOpening },
  mixins: [],
  data() {
    return {
      loading: false,
    };
  },
  watch: {},
  created() {},
  methods: {
    closeAccountOpening() {
      bus.$emit('close_current_tags');
      this.$router.replace('/paymentAccount');
    },
  },
};
</script>

<style lang="scss" scoped></style>
